import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Pencil, Trash2 } from 'lucide-react';

const JournalCard = ({ journal, isAdmin = false, onEdit, onDelete }) => {
  return (
    <div
      className="bg-white border border-[#E5E7EB] flex flex-col h-full"
      data-testid={`journal-card-${journal.id}`}
    >
      {/* Color accent */}
      <div className="h-1 bg-[#1A73E8]" />
      <div className="flex items-center justify-between px-4 pt-3 pb-0">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 bg-[#F5F7FA] border border-[#E5E7EB] flex items-center justify-center flex-shrink-0">
            <BookOpen size={13} className="text-[#1A73E8]" />
          </div>
          <span className="text-xs font-semibold uppercase tracking-widest text-[#1A73E8]">{journal.shortTitle}</span>
        </div>
      </div>

      <div className="p-5 pt-3 flex flex-col flex-1">
        <h3 className="font-serif text-[#1F1F1F] text-lg font-semibold leading-snug mb-2">
          {journal.title}
        </h3>

        <p className="text-[#6B7280] text-sm leading-relaxed flex-1 line-clamp-3 mb-4">
          {journal.description}
        </p>

        {/* Field + Frequency (no ISSN, no impact factor) */}
        <div className="grid grid-cols-2 gap-2 mb-4 text-xs">
          <div className="bg-[#F5F7FA] px-3 py-2 border border-[#E5E7EB]">
            <span className="text-[#6B7280] block">Field</span>
            <span className="text-[#1F1F1F] font-medium">{journal.field?.split('&')[0]?.trim()}</span>
          </div>
          <div className="bg-[#F5F7FA] px-3 py-2 border border-[#E5E7EB]">
            <span className="text-[#6B7280] block">Frequency</span>
            <span className="text-[#1F1F1F] font-medium">{journal.frequency}</span>
          </div>
        </div>

        <Link
          to={`/journals/${journal.id}`}
          className="flex items-center justify-between px-4 py-2.5 border border-[#1A73E8] text-[#1A73E8] text-sm font-medium hover:bg-[#1A73E8] hover:text-white transition-colors"
          data-testid={`view-journal-${journal.id}`}
        >
          View Journal Details
        </Link>

        {/* Admin controls */}
        {isAdmin && (
          <div className="flex gap-2 mt-3 pt-3 border-t border-[#E5E7EB]">
            <button
              onClick={() => onEdit && onEdit(journal)}
              className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 border border-[#E5E7EB] text-xs text-[#374151] hover:bg-[#F5F7FA] hover:border-[#1A73E8] hover:text-[#1A73E8] transition-colors"
              data-testid={`edit-journal-${journal.id}`}
            >
              <Pencil size={12} /> Edit
            </button>
            <button
              onClick={() => onDelete && onDelete(journal)}
              className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 border border-[#E5E7EB] text-xs text-[#374151] hover:bg-red-50 hover:border-red-300 hover:text-red-600 transition-colors"
              data-testid={`delete-journal-${journal.id}`}
            >
              <Trash2 size={12} /> Delete
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default JournalCard;
